import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import CookieConsent from './components/CookieConsent/CookieConsent';
import { usePageTracking } from './hooks/usePageTracking';
import BlogPage from './pages/BlogPage';
import PostPage from './pages/PostPage';
import SobrePage from './pages/SobrePage';
import ContatoPage from './pages/ContatoPage';
import './App.css';
import './variables.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function PageTracking() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="app-shell">
        <Header />

        <div className="app-main">
          <Routes>
            <Route path="/" element={<BlogPage />} />
            <Route path="/post/:slug" element={<PostPage/>}/>
            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/contato" element={<ContatoPage />} />
          </Routes>
        </div>

        {/* Depois das Routes de propósito: os efeitos do React rodam nessa
            ordem, então o document.title já foi atualizado pela página atual
            quando o pageview é enviado. */}
        <PageTracking />

        <Footer />
        <CookieConsent />
      </div>
    </BrowserRouter>
  );
}

export default App;